import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { env } from '../../../app.constant';
import { tap } from 'rxjs/operators';
import { ApiResponse, AvailableChartAccountParams, ChartAccount, ChartAccountParams } from '../../data/system/chartacount';

@Injectable()
export class ChartAccountService extends ChartAccount {

  constructor(private http: HttpClient) { super(); }

  getChartAccount(params: ChartAccountParams): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.account_charts_get}`;
    return this.http.post<ApiResponse>(host, params).pipe(
      tap(data => console.log(`chartsAccount->list->data`, data))
    );
  }

  getAvailableChartAccount(params: AvailableChartAccountParams): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.account_charts_get_available}`;
    return this.http.post<ApiResponse>(host, params).pipe(
      tap(data => console.log(`availableChartsAccount->data`, data))
    );
  }

  getChartAccountByFundCodeCollection(params: any): Observable<any> {
    const host = `${env.host}${env.endpoint.account_get_by_fund_collection}`;
    return this.http.post<any>(host, params);
  }

  getChartAccountsRealignment(type: string) {
    const host = `${env.host}${env.endpoint.account_charts_get_realignment}`;
    return this.http.post<any>(host, { type });
  }

}
